ixModuleRouting("impactx.quota", {
    "/quotalist": {
        template: "<ixa-quota-list></ixa-quota-list>",
        templateUrl: "modules/quota/templates/quotalist.html",
        process: "ListQuota",
        controller: "QuotaListCtrl",
        controllerAs: "quotaListCtrl",
        workspace: "content",
    },
    "/quotastatlist": {
        template: "<ixa-quota-stat-list></ixa-quota-stat-list>",
        templateUrl: "modules/quota/templates/quotastatlist.html",
        process: "ListQuotaStat",
        controller: "QuotaStatListCtrl",
        controllerAs: "quotaStatListCtrl",
        workspace: "content",
    },
    "/quota/:id": {
        template: "<ixa-quota-detail></ixa-quota-detail>",
        templateUrl: "modules/quota/templates/quota.html",
        process: "ViewQuota",
        controller: "QuotaCtrl",
        controllerAs: "quotaCtrl",
        workspace: "content",
    },
});
